export class PxlMedicationRoutingRouteNames {
    public static readonly MedicationSources = 'medication-sources';
    public static readonly MedicationReminders = 'reminders';
}
